import React, { Fragment, useEffect, useState, useCallback } from 'react';

import StatsModal from './statsModal';
import debounce from 'lodash/debounce';
import { request } from '../../../services/utilities';
import moment from 'moment';
import SearchStaffs from '../../SearchStaffs';
import SlidingPane from '../../SlidingPane';

// ... (other imports remain the same)

const AnalysisBystaff = ({ slug, module }) => {
	// ... (other state variables remain the same)
	const [selectedStaff, setSelectedStaff] = useState(null);
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [isSearching, setIsSearching] = useState(false);
	const [searchError, setSearchError] = useState(null);
	const [searchTerm, setSearchTerm] = useState('');
	const [staffs, setStaffs] = useState([]);
	const [showModal, setShowModal] = useState(false);
	//   const [statsData, setStatsData] = useState({
	// 	checkedInToday: '',z

	const [loaded, setLoaded] = useState(false);
	const [stats, setStats] = useState(null);
	const [departments, setDepartments] = useState([]);
	const [totalPatients, setTotalPatients] = useState();
	const [startDate, setstartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [appointments, setAppointments] = useState();
	const [focus, setFocus] = useState(false);
	const [totalAdmissions, setTotalAdmissions] = useState();
	const [statsData, setstatData] = useState({
		checkedInToday: '',
		waitingForConsultation: '',
		dischargedToday: '',
		emergencyCases: '',
		scheduledAppointments: '',
		walkInPatients: '',
		noShowPatients: '',
	});

	const [critical, setCritical] = useState();
	const [walkIns, setWalkIns] = useState();
	const todaysDate = moment().format('YYYY-MM-DD');

	// Debounced search function
	const debouncedFindStaff = useCallback(
		debounce(async searchTerm => {
			if (!searchTerm.trim()) {
				setStaffs([]);
				setIsSearching(false);
				return;
			}

			try {
				const res = await request(`hr/staffs?page=1&limit=10&q=${searchTerm}&status=&include_stats=1&department_id=`, 'GET', true);
				setStaffs(res?.result || []);
				setSearchError(null);
			} catch (error) {
				setSearchError('Failed to fetch staff');
				setStaffs([]);
			} finally {
				setIsSearching(false);
			}
		}, 300),
		[]
	);

	const handleSearchChange = e => {
		const value = e.target.value;
		setSearchTerm(value);
		setIsSearching(true);
		debouncedFindStaff(value);
	};

	const handleStaffSelect = staff => {
		setSelectedStaff(staff);
		setSearchTerm(`${staff.first_name} ${staff.last_name}`);
		setIsDropdownOpen(false);
	};

	const handleInputFocus = () => {
		if (searchTerm && staffs.length > 0) {
			setIsDropdownOpen(true);
		}
	};

	const handleClearSelection = () => {
		setSelectedStaff(null);
		setSearchTerm('');
		setStaffs([]);
	};

	// ... (other functions remain the same)

	return (
		<Fragment>
			<div className="content-i" style={{ position: 'relative' }}>
				<div className="content-box" style={{ position: 'relative' }}>
					<div className="search-bar d-flex justify-content-end w-100" style={{ marginBottom: '20px' }}>
						{focus ? (
							<SearchStaffs
								slug={slug}
								setSelectedStaff={setSelectedStaff}
								selectedStaff={selectedStaff}
								setFocus={setFocus}
								setShowModal={setShowModal}
								style={'none'}
							/>
						) : (
							<div
								style={{ position: 'relative', width: '100%', paddingTop: '10px', paddingBottom: '10px', justifyItems: 'center' }}
								className=" d-flex justify-content-end w-100"
							>
								<div className="d-block rounded" style={{ position: 'relative' }}>
									<input
										onClick={() => setFocus(true)}
										type="text"
										id="staff-search"
										value={searchTerm}
										onChange={handleSearchChange}
										onFocus={handleInputFocus}
										placeholder="Search staff name"
										style={{
											padding: '8px 12px',
											margin: '0 10px',
											textAlign: 'center',
											borderRadius: '100px',
											border: '1px solid #ddd',
											width: '300px',
										}}
									/>
								</div>

								{/* <button
								onClick={() => setShowModal(true)}
								disabled={!selectedStaff}
								style={{
									padding: '8px 16px',
									background: selectedStaff ? '#4CAF50' : '#cccccc',
									color: 'white',
									border: 'none',
									borderRadius: '4px',
									cursor: selectedStaff ? 'pointer' : 'not-allowed',
									marginTop: '0px',
								}}
							>
								Fetch Stats
							</button> */}
							</div>
						)}
					</div>

					{/* Modal remains the same */}

					<SlidingPane isOpen={showModal}>
						<StatsModal
							module={module}
							selectedStaff={selectedStaff}
							showModal={showModal}
							setFocus={setFocus}
							onClose={() => setShowModal(false)}
						/>
					</SlidingPane>
				</div>
			</div>
		</Fragment>
	);
};

export default AnalysisBystaff;
